<template>
  <div @click="checkCreate">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { USER_LEVEL_KEY } from '~/api/interface';
import { USER_ADMIN } from '~/constants';
import { PageKey } from '~/constants/page';
const accountList = useAccountList();

const emits = defineEmits(['cancel']);
const router = useRouter();

const checkCreate = () => {
  emits('cancel');
  // 如果有体验版账号
  const tasteAccounts = accountList.value.filter(item => {
    return (
      Number(item.rights_type) === USER_LEVEL_KEY.TEAM_TASTE &&
      Number(item.permission) !== USER_ADMIN.NORMAL
    );
  });

  if (tasteAccounts.length > 0) {
    const showCreateModal = useCheckCreate();
    showCreateModal.value = true;
  } else {
    router.push({
      name: PageKey.TEAM_TASTE_CREATE,
    });
  }
};

defineExpose({
  check: checkCreate,
});
</script>

<style lang="scss" scoped></style>
